import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { getLabel } from '../../utils';

import SearchBarHolder from './SearchBarStyles';

const SimpleSearch = props => {
	const [searchTerm, setSearchTerm] = useState("");
	const inputRef = useRef(null);

	useEffect(() => {
		if (props.active) {
			document.addEventListener("keydown", (e) => props.handleEscape(e, props.searchClickHandler));
		} else {
			document.removeEventListener("keydown", (e) => props.handleEscape(e, props.searchClickHandler));
		}
		setTimeout(()=>{
			if (props.active && inputRef && inputRef.current) {
				inputRef.current.focus();
			}
		},500);
	}, [props.active]);

	const handleKeyPress = (e) => {
		if (e.key === 'Enter' || e.keyCode === 13) {
			searchClickHandler(e);
		}
	}

	const searchTermChange = (e) => {
		setSearchTerm(e.target.value.replaceAll(":", "%5C%3A").replaceAll("{", "").replaceAll("}", "").replaceAll("[", "").replaceAll("]", ""));
	}

	const searchClickHandler = (e) => {
		e.preventDefault();
		const searchUrl = props.searchpages[props.current_lang];
		window.location.href = `${searchUrl}?key=${searchTerm}`;
	}

	return (
		<SearchBarHolder>
				<div className="sidebar-container">
					<input
						aria-label={getLabel("SEARCH")}
						name={getLabel("SEARCH")}
						placeholder={getLabel("SEARCHPLACEHOLDER")}
						onChange={searchTermChange}
						onKeyDown={(e)=>handleKeyPress(e)}
						ref={ inputRef }
						type="text"
					></input>
					<button onClick={(e) => searchClickHandler(e)}>{getLabel("SEARCH")}</button>
				</div>
		</SearchBarHolder>
	)
}

const mapStateToProps = (store) => ({
	current_lang: store.language.current,
	searchpages: store.search.pages
});
  
export default connect(mapStateToProps,null)(SimpleSearch);
